module.exports = __webpack_public_path__ + "static/media/previewheader.151f54ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/previewheader.png
// module id = 140
// module chunks = 0